import React, { useState } from 'react';
import { List, Typography, Row } from 'antd';
import FileRenderer from './FileRenderer';
import FileIcon from "./FileIcon";
import IconButton from '@mui/material/IconButton';
import {FileOpenRounded} from "@mui/icons-material";


const FileList = ({ files, title=null }) => {
  const [currentFile, setCurrentFile] = useState('');
  const [visible, setVisible] = useState(false);

  const handleFileClick = (file) => {
    setCurrentFile(file);
    setVisible(true);  // Show the modal when a file is clicked
  };

  return (
    <>
      <List
        bordered={false}
        header={title}
        dataSource={files}
        renderItem={item => (
          <List.Item
            className={'px-3'}
            onClick={() => handleFileClick(item)}
            actions={[<IconButton><FileOpenRounded color={'primary'} /></IconButton>]}
          >
            <FileIcon filename={item} />
            {item.split('/').pop()}
          </List.Item>
        )}
      />
      {currentFile && <FileRenderer uri={currentFile} title={currentFile.split('/').pop()} visible={visible} setVisible={setVisible} />}
    </>
  );
};


export default FileList;
